import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { setupAnalytics } from './plugins/analytics'
import i18n from './plugins/i18n'

const app = createApp(App)

// Router installieren
app.use(router)

// i18n installieren
app.use(i18n)

// Google Analytics setup (initial disabled)
setupAnalytics(router)

// App mounten
app.mount('#app')


